import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { RiskType } from "../mutation/useAddRIskMutation";

export type RIskResponse = ResponseType<RiskType[]>;

function useAllRiskQuery(projectId: string) {
  return useQuery<
    AxiosResponseAndError<RIskResponse>["response"],
    AxiosResponseAndError<RIskResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.risk,projectId],
    queryFn: async () => await ApiRequest.get(requestURLs.risk + projectId),
    enabled: Boolean(projectId),
  });
}

export default useAllRiskQuery;
